module.exports = __webpack_public_path__ + "img/esgtree.e3443544.png";